import styled from 'styled-components'

export const HeaderMobile = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 24px;
`
